<template>
    <img :src="$store.state.formSuccess && $store.state.argann != '' ? `https://action.metaffiliation.com/trk.php?mclic=${ pixel }&argann=${ $store.state.argann }&altid=${ $store.state.altid }` : ''" width="1" height="1" border="0"/>
</template>

<script>
export default {
    name: 'Pixel',
    data() {
        return {
            pixel: process.env.VUE_APP_MCLIC,
        };
    },
};
</script>

<style>

</style>
